/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import StatsBar from '../../Common/StatsBar';
import { getStatsBarData, getSponsorData } from '../../../utils/utils';
import ImgCrop from '../../Common/ImgCrop';
import Sponsor from '../../Common/Sponsor';
import { CONTENT_TYPE } from '../../../constants/globalConstants';
import * as track from '../../../utils/analytics';
import { QUIZ_MODAL } from '../../../constants/containerConstants';

const EndScreen = (props) => {
  const { t, data, itemid, quizExpired, message, showQuiz, trackCard } = props;
  const { manutds, Title, ContentType } = data;
  const sponsorData =
    data && data.Sponsorby && data.Sponsorby.fields && getSponsorData(data.Sponsorby.fields);

  return (
    <div className="grid-12 cover-card quiz-cover">
      <div className="mu-content">
        <div className="img-holder">
          {data.BackgroundImage &&
            data.BackgroundImage.value &&
            data.BackgroundImage.value.Crops && (
              <ImgCrop
                imgCrop={data.BackgroundImage.value.Crops}
                singleSrc={false}
                alt=""
                title={data.Title && data.Title.value}
                isWebpAvailable={data.BackgroundImage.value.isWebpAvailable}
              ></ImgCrop>
            )}
        </div>
        <div
          className="mu-item__info"
          onClick={(e) => {
            trackCard(data, e, 'card', {
              content_type: 'question',
              card_name: Title && Title.value,
              teaser: data.Teaser && data.Teaser.value,
              container_type: QUIZ_MODAL,
            });
          }}
        >
          <Sponsor
            masterClass="mu-item__quiz-sponsor"
            contentType={data.ContentType && data.ContentType.value}
            varient=""
            sponsorInfo={sponsorData}
            grid={'grid-12'}
            type={CONTENT_TYPE}
            author={manutds && manutds.value && manutds.value.Author}
            cardName={data.Title && data.Title.value}
            container={QUIZ_MODAL}
            createdDateTime={data.__Published && data.__Published.value}
            itemId={itemid}
            tags={manutds && manutds.value.Tags}
          ></Sponsor>
          <h2 className="mu-item__title" id="dialog1_label">
            {data && data.Title && data.Title.value}
          </h2>
          {!quizExpired && (
            <p className="mu-item__teasure">
              {data && data.Introduction && data.Introduction.value}
            </p>
          )}
          {quizExpired && <p className="mu-item__teasure">{message}</p>}
          {!quizExpired && (
            <div
              className="red-btn-skew showQuizButton"
              onClick={(e) => {
                showQuiz(e);
              }}
              onKeyPress={(e) => {
                showQuiz(e);
              }}
              tabIndex="0"
            >
              <span className="red-btn-skew-link">{t('StartQuiz')}</span>
            </div>
          )}
        </div>
      </div>
      <StatsBar item={getStatsBarData(data)} classes="quiz-statsbar" type="quiz"></StatsBar>
    </div>
  );
};
export default withTranslation()(EndScreen);
